<template>
    <div class="distribution-agents">
        <loader v-if="loading" />
        <v-row v-else>
            <v-col>
                <v-card>
                    <v-card-text>
                        <v-subheader>
                            <v-row>
                                <v-col cols="2">
                                    Navn
                                </v-col>
                                <v-col>
                                    Tidligere niveau
                                </v-col>
                                <v-col>
                                    Solgt præmie
                                </v-col>
                                <v-col>
                                    Salg pr. emne
                                </v-col>
                                <v-col cols="2">
                                    Salg pr. tildelt møde 14 dage
                                </v-col>
                                <v-col>
                                    Aktiv
                                </v-col>
                                <v-col>
                                    Besvarelser
                                </v-col>
                                <v-col>
                                    TMK
                                </v-col>
                                <v-col>
                                    Bonus
                                </v-col>
                                <v-col>
                                    Gennemgang
                                </v-col>
                            </v-row>
                        </v-subheader>
                        <v-list class="striped-list">
                            <v-list-item v-for="agent in filteredAgents" :key="agent.name">
                                <v-row>
                                    <v-col cols="2">
                                        <div v-line-clamp="1">
                                            <v-icon v-if="!settings.levels[level + 1] && agent.newLevel === agent.level" color="green darken-2" x-small>fa-arrow-right</v-icon>
                                            <v-icon v-else-if="agent.newLevel > agent.level" color="green darken-2" x-small>fa-arrow-up</v-icon>
                                            <v-icon v-else-if="agent.newLevel < agent.level" color="red" x-small>fa-arrow-down</v-icon>
                                            <v-icon v-else color="yellow darken-3" x-small>fa-arrow-right</v-icon>
                                            &nbsp;
                                            <span v-if="!settings.levels[level + 1] && agent.newLevel === agent.level" class="green--text text--darken-2">{{ agent.name }}</span>
                                            <span v-else-if="agent.newLevel > agent.level" class="green--text text--darken-2">{{ agent.name }}</span>
                                            <span v-else-if="agent.newLevel < agent.level" class="red--text">{{ agent.name }}</span>
                                            <span v-else class="yellow--text text--darken-3">{{ agent.name }}</span>
                                        </div>
                                    </v-col>
                                    <v-col>
                                        {{ agent.oldLevel }}
                                    </v-col>
                                    <v-col>
                                        {{ agent.total | separator }}
                                    </v-col>
                                    <v-col>
                                        <span v-if="!settings.levels[level + 1]" class="green--text text--darken-2">{{ agent.avgLead | separator }}</span>
                                        <span v-else-if="settings.levels[level + 1] && agent.avgLead >= settings.levels[level + 1].minimumAvgLead" class="green--text text--darken-2">{{ agent.avgLead | separator }}</span>
                                        <span v-else-if="agent.avgLead >= settings.levels[level].minimumAvgLead" class="yellow--text text--darken-2">{{ agent.avgLead | separator }}</span>
                                        <span v-else class="red--text">{{ agent.avgLead | separator }}</span>
                                    </v-col>
                                    <v-col cols="2">
                                        <span v-if="!settings.levels[level + 1] && (agent.periodMeetingCount < settings.minimumPeriodMeetingCount || agent.avgMeeting >= settings.levels[level].minimumAvgMeeting)" class="green--text text--darken-2">{{ agent.avgMeeting | separator }}{{ ` (${agent.periodMeetingCount})` }}</span>
                                        <span v-else-if="settings.levels[level + 1] && (agent.periodMeetingCount < settings.minimumPeriodMeetingCount || agent.avgMeeting >= settings.levels[level + 1].minimumAvgMeeting)" class="green--text text--darken-2">{{ agent.avgMeeting | separator }}{{ ` (${agent.periodMeetingCount})` }}</span>
                                        <span v-else-if="agent.avgMeeting >= settings.levels[level].minimumAvgMeeting" class="yellow--text text--darken-2">{{ agent.avgMeeting | separator }}{{ ` (${agent.periodMeetingCount})` }}</span>
                                        <span v-else class="red--text">{{ agent.avgMeeting | separator }}{{ ` (${agent.periodMeetingCount})` }}</span>
                                    </v-col>
                                    <v-col>
                                        <v-icon v-if="!agent.efficiencyRequirement || agent.effectiveDuration >= settings.minimumEffectiveDuration" color="green">fas fa-circle</v-icon>
                                        <v-icon v-else color="red">fas fa-circle</v-icon>
                                    </v-col>
                                    <v-col>
                                        <v-icon v-if="agent.responseCount >= settings.minimumResponseCount" color="green">fas fa-circle</v-icon>
                                        <v-icon v-else color="red">fas fa-circle</v-icon>
                                    </v-col>
                                    <v-col>
                                        <v-icon v-if="agent.TMK >= settings.minimumTMK" color="green">fas fa-circle</v-icon>
                                        <v-icon v-else color="red">fas fa-circle</v-icon>
                                    </v-col>
                                    <v-col>
                                        <v-icon v-if="agent.bonus >= settings.minimumBonus" color="green">fas fa-circle</v-icon>
                                        <v-icon v-else color="red">fas fa-circle</v-icon>
                                    </v-col>
                                    <v-col>
                                        <v-icon v-if="agent.examination >= settings.minimumExamination" color="green">fas fa-circle</v-icon>
                                        <v-icon v-else color="red">fas fa-circle</v-icon>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
            loading: true,
            agents: []
        }
    },
    computed: {
        department () {
            return this.$store.state.main.department || this.$store.getters['distribution/department']
        },
        filteredAgents () {
            const agents = this.agents
            return agents
                .filter(agent => agent.level === this.level)
                .sort((a, b) => {
                    if (a.newLevel === b.newLevel) {
                        if (this.level === this.settings.levels.length - 1) {
                            return a.total > b.total ? -1 : 1
                        } else return a.avgLead > b.avgLead ? - 1 : 1
                    } else return a.newLevel > b.newLevel ? -1 : 1
                })
        },
        settings () {
            return this.$store.getters['distribution/settings']
        },
        level () {
            return this.$store.state.distribution.level
        },
        date () {
            return this.$store.state.distribution.date
        }
    },
    methods: {
        async getData () {
            this.loading = true
            const response = await this.$http().get(`distribution/${this.department}/agents/${this.date}`)
            this.agents = response.data
            this.loading = false
        }
    },
    watch: {
        department: function () {
            this.getData()
        },
        date: function () {
            this.getData()
        }
    },
    async created () {
        this.getData()
    }
}
</script>